import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from 'react'

import {
  SanityHeroModule,
  SanityModule,
} from '@data/sanity/queries/types/modules'
import { isEqual } from './helpers'
import { getFilteredHeroModules } from './module'

interface PageHeroContextProps {
  sourcePage?: string
  targetPage?: string
  heroModule?: SanityModule
  caseHeroModule?: SanityHeroModule
  heroCaseVideoCarouselDisabled: boolean
  setSourcePage: Dispatch<SetStateAction<string | undefined>>
  setTargetPage: Dispatch<SetStateAction<string | undefined>>
  setCaseHeroModule: Dispatch<SetStateAction<SanityHeroModule | undefined>>
  setHeroCaseVideoCarouselDisabled: Dispatch<SetStateAction<boolean>>
}

interface PageHeroContextProviderProps {
  modules?: SanityModule[] | null
  children: ReactNode
}

export const PageHeroContext = createContext<PageHeroContextProps>({
  heroCaseVideoCarouselDisabled: false,
  setSourcePage: () => {},
  setTargetPage: () => {},
  setCaseHeroModule: () => {},
  setHeroCaseVideoCarouselDisabled: () => {},
})

export const PageHeroContextProvider = ({
  modules,
  children,
}: PageHeroContextProviderProps) => {
  const [sourcePage, setSourcePage] = useState<string>()
  const [targetPage, setTargetPage] = useState<string>()
  const [heroModule, setHeroModule] = useState<SanityModule | undefined>(() => {
    return getFilteredHeroModules(modules ?? [])?.[0]
  })
  const [caseHeroModule, setCaseHeroModule] = useState<SanityHeroModule>()
  const [heroCaseVideoCarouselDisabled, setHeroCaseVideoCarouselDisabled] =
    useState(false)

  // Update hero module when a new page is loaded
  useEffect(() => {
    const filteredModule = getFilteredHeroModules(modules ?? [])?.[0]

    if (!isEqual(filteredModule, heroModule)) {
      setHeroModule(filteredModule)
    }
  }, [modules, heroModule])

  return (
    <PageHeroContext.Provider
      value={{
        sourcePage,
        targetPage,
        heroModule,
        caseHeroModule,
        heroCaseVideoCarouselDisabled,
        setSourcePage,
        setTargetPage,
        setCaseHeroModule,
        setHeroCaseVideoCarouselDisabled,
      }}
    >
      {children}
    </PageHeroContext.Provider>
  )
}
